const messages = {
    es:{
        translations:{
               
            titulos:{
                titulo: 'Piña',
                tituloSobre: 'Sobre la piña',
                Efruta: '¿Es realmente fruta?'
            },

            textos:{
                abacaxi:'Las piñas son frutas tropicales amarillentas.',
                abacaxiSobre: 'La piña es un buen aliado. Después de todo, tiene vitaminas, minerales y enzimas, como la bromelina. Estos nutrientes ayudan a fortalecer el sistema inmunológico y eliminar la inflamación en el cuerpo. Ayuda en la pérdida de peso: al ser un alimento diurético, la piña ayuda en la eliminación de líquidos y toxinas del organismo.',
                abacaxiE: 'La piña, la fresa y el higo son frutas, ¿verdad? ¡Equivocado! Son las infrutescencias: resultado de la fusión de varias flores que, tras ser fecundadas, se unen en un solo fruto o infrutescencia.'
            },

            seletores:{
                escolhaIdioma: 'Elige un idioma',
                idioma1: 'Portugués de Brasil',
                idioma2: 'Inglés',
                idioma3: 'Español',
            },

            botoes:{
                comprarAbacaxi: '¿Compra?'
            }
        }
    }
}
export {messages}